import { render } from "./DocumentsLGAll.vue?vue&type=template&id=122f7526&scoped=true"
import script from "./DocumentsLGAll.vue?vue&type=script&lang=js"
export * from "./DocumentsLGAll.vue?vue&type=script&lang=js"

import "./DocumentsLGAll.vue?vue&type=style&index=0&id=122f7526&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122f7526"]])

export default __exports__